var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"white"}},[_c('div',[_vm._v("爱上街风控升级，两天后开放做单")])])
}]

export { render, staticRenderFns }